(function($){
    'use strict';
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

    function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    var testingLocally = location.host.indexOf(':') !== -1;

    var GoogleMaps = function () {
    function GoogleMaps() {
        var mapClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.gMap';

        _classCallCheck(this, GoogleMaps);

        this.mapClass = mapClass;
        this.mapContainers = document.querySelectorAll(mapClass);

        this.dataAttr = {
            mapLat: 'data-lat',
            mapLng: 'data-lng',
            mapZoom: 'data-zoom',
            mapControls: 'data-controls',
            mapMarker: 'data-marker',
            markerLat: 'data-marker-lat',
            markerLng: 'data-marker-lng',
            mapAddress: 'data-address'
        };
    }

    _createClass(GoogleMaps, [{
        key: 'createMarker',
        value: function createMarker(mapContainer, componentId, initMap) {
            var markerLat = mapContainer.getAttribute(this.dataAttr.markerLat);
            var markerLng = mapContainer.getAttribute(this.dataAttr.markerLng);

            try {
                if (markerLat == null || markerLng == null) throw true;
                if (markerLat.length == 0 || markerLng.length == 0) throw true;
            } catch (err) {
                console.error('Can\'t create marker for  map (#' + componentId + ') becuase either data-marker-lat or data-marker-lng is not defined or has empty value');
                return;
            }

            var markerPos = {
                lat: parseFloat(markerLat),
                lng: parseFloat(markerLng)
            };

            
            var newMaker = new google.maps.Marker({
                position: markerPos,
                map: initMap
            });
        }
    }, {
        key: 'createMap',
        value: function createMap(mapContainer, componentId) {
            var _this13 = this;

            //initialise geocoder service if address found
            var address = mapContainer.getAttribute(this.dataAttr.mapAddress);
            if (address) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': address }, function (results, status) {

                    if (status == google.maps.GeocoderStatus.OK) {
                        var mapPosLat = results[0].geometry.location.lat();
                        var mapPosLng = results[0].geometry.location.lng();

                        try {
                            if (mapPosLat == null || mapPosLng == null) throw true;
                            if (mapPosLat.length == 0 || mapPosLng.length == 0) throw true;
                        } catch (err) {
                            console.error('Can\'t initialize map (#' + componentId + ') becuase either data-lat or data-lng is not defined or has empty value');
                            return;
                        }

                        var mapZoom = mapContainer.getAttribute(_this13.dataAttr.mapZoom) || 10;
                        var disableControls = mapContainer.getAttribute(_this13.dataAttr.mapControls) == 'false' ? true : false;
                        var disableScroll = mapContainer.getAttribute(_this13.dataAttr.mapScroll) == 'false' ? false : true;

                        var addMarkerValue = mapContainer.getAttribute(_this13.dataAttr.mapMarker);
                        var addMarkerCheck = addMarkerValue !== null ? JSON.parse(addMarkerValue) : false;

                        var mapSettings = {
                            zoom: parseInt(mapZoom),
                            controls: disableControls,
                            scroll: disableScroll,
                            position: {
                                lat: parseFloat(mapPosLat),
                                lng: parseFloat(mapPosLng)
                            }
                        };

                        var initMap = new google.maps.Map(mapContainer, {
                            zoom: mapSettings.zoom,
                            center: mapSettings.position,
                            disableDefaultUI: mapSettings.controls,
                            scrollwheel: mapSettings.scroll
                        });

                        if (addMarkerCheck) {
                            var markerPos = mapSettings.position;

                            var newMaker = new google.maps.Marker({
                                position: markerPos,
                                map: initMap
                            });
                        }
                    } else {
                        console.log(status);
                    }
                });
            } else {
                var mapPosLat = mapContainer.getAttribute(this.dataAttr.mapLat);
                var mapPosLng = mapContainer.getAttribute(this.dataAttr.mapLng);

                try {
                    if (mapPosLat == null || mapPosLng == null) throw true;
                    if (mapPosLat.length == 0 || mapPosLng.length == 0) throw true;
                } catch (err) {
                    console.error('Can\'t initialize map (#' + componentId + ') becuase either data-lat or data-lng is not defined or has empty value');
                    return;
                }

                var mapZoom = mapContainer.getAttribute(this.dataAttr.mapZoom) || 10;
                var disableControls = mapContainer.getAttribute(this.dataAttr.mapControls) == 'false' ? true : false;
                var disableScroll = mapContainer.getAttribute(this.dataAttr.mapScroll) == 'false' ? false : true;

                var addMarkerValue = mapContainer.getAttribute(this.dataAttr.mapMarker);
                var addMarkerCheck = addMarkerValue !== null ? JSON.parse(addMarkerValue) : false;

                var mapSettings = {
                    zoom: parseInt(mapZoom),
                    controls: disableControls,
                    scroll: disableScroll,
                    position: {
                        lat: parseFloat(mapPosLat),
                        lng: parseFloat(mapPosLng)
                    }
                };

                var initMap = new google.maps.Map(mapContainer, {
                    zoom: mapSettings.zoom,
                    center: mapSettings.position,
                    disableDefaultUI: mapSettings.controls,
                    scrollwheel: mapSettings.scroll
                });

                if (addMarkerCheck) this.createMarker(mapContainer, componentId, initMap);
            }
        }
    }, {
        key: 'init',
        value: function init() {
            var _this14 = this;

            [].concat(_toConsumableArray(this.mapContainers)).forEach(function (mapContainer, mapIndex) {
                var componentId = _this14.mapClass.slice(1) + '-' + (mapIndex + 1);

                mapContainer.setAttribute('id', componentId);
                _this14.createMap(mapContainer, componentId);
            });
        }
    }]);

    return GoogleMaps;
}();

    /* ==== CONTENT GOOGLE MAPS ==== */
    var loadMap = $(".gMap").length > 0 ? true : false;
    if(loadMap) {
        var gMaps = new GoogleMaps();
        gMaps.init();
    }
}(jQuery));
